import React, { useEffect, memo } from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "../redux/dailyPulseSagas";
import { createSelector } from "reselect";

export const withLoadingAnimation = (WrappedComponent, key, urn) => {
  function NewComponent({ notifications, ...rest }) {
    const dispatch = useDispatch();

    const selectData = (state) => state.dailyPulse.sections[key];
    const selectDate = (state) => state.dailyPulse.date;

    const selector = createSelector([selectDate, selectData], (date, data) => {
      return { date, data };
    });

    const { date, data: { isLoading, chartData } = {} } = useSelector(selector);

    useEffect(() => {
      if (date) {
        dispatch(actionCreators.fetchSectionData({ key, urn }));
      }
    }, [date]);

    if (isLoading) return <LoadingAnimation text="Loading..." />;
    return (
      <ErrorBoundary moduleName={`dailyPulse ${key}`} {...notifications}>
        <WrappedComponent chartData={chartData} {...rest} />
      </ErrorBoundary>
    );
  }
  return memo(NewComponent);
};
